import axios from 'axios';
import Cookies from 'js-cookie';

import { IP_COOKIES } from 'state/constants';
import Log from 'utils/Log';

import { API_URL } from './constants';

class IpAPI {
  static async getUserIP() {
    const cookie = Cookies.get(IP_COOKIES.USER_IP);

    if (cookie) {
      return cookie;
    }

    let ip = null;
    try {
      const response = await axios.get(API_URL);

      ip = response.data.ip;
    } catch (error) {
      Log.error(error, 'api:IP.getUserIP request failed!');
    }

    return ip;
  }
}

export default IpAPI;
